<template>
    <div>
            <div>
                <b-button class="mr-2 mt-2" variant="danger" @click="ShowModal1">紙本票銷退掃描(倉庫使用)</b-button>
                <b-button class="mr-2 mt-2" variant="success" :disabled="$bus.session.role_type === 'logistic_small'" @click="ShowModal2">紙本票作廢掃描(總部使用)</b-button>
                <!-- :disabled="$bus.session.role_type !== 'sys_admin'" -->
            </div>
            <b-modal
            id="modal-1"
            ref="modal-1"
            v-model="showScanner"
            size="lg"
            centered
            :static="true"
            ok-title="全部送出RA"
            v-on:ok="sendToNSRA"
            cancel-title="全部清除"
            v-on:cancel="clear"
            >
                <p>倉儲銷退流程</p>
                <p>點擊白底或方框開始掃描:</p>
                <Scanner id="Scanner1" v-if="showScanner == true" :customFunction="parentMethod" >
                </Scanner>
                <input type="text" v-model="scanned_ticket">
                <div>{{ inputLists }}</div>
            </b-modal>
            <b-modal
            id="modal-2"
            ref="modal-2"
            v-model="showScanner2"
            size="lg"
            centered
            :static="true"
            ok-title="全部送出作廢"
            v-on:ok="sendToNSInvalid"
            cancel-title="全部清除"
            v-on:cancel="clear2"
            >
                <p>總部作廢流程</p>
                <div>
                    <input type="checkbox" id="checkbox" v-model="checkedRA">
                    <label for="checkbox">補RA/跳過檢查</label>
                    <p>{{ checkedRA }}</p>
                </div>
                <p>點擊白底或方框開始掃描:</p>
                <Scanner id="Scanner2" v-if="showScanner2 == true " :customFunction="parentMethod2">
                </Scanner>
                <input type="text" v-model="scanned_ticket2">
                <div>{{ inputLists2 }}</div>
            </b-modal>
        <div class="mask" style="background-color:rgba(0,0,0,0.5); width: 100%; height: 100%; position:fixed; top :0;" v-if="isShow">
        </div>
        <div class="d-flex justify-content-center align-items-center mt-3 mb-3" v-if="isShow">
            <strong>Loading...</strong>
            <b-spinner></b-spinner>
        </div>
    </div>
</template>
<script>
import Scanner from '../Common/Scanner';
import {
    apiCheckScannedPaperTicket
} from '@/api/AdminManage.js'

import {
    apiBatchTrashPaperOrderTickets,
} from '@/api/Order.js'

export default {
    name:'PaperSalesReturn',
    components: {
        Scanner,
    },
    data(){
        return{
            showScanner: false,
            showScanner2: false,
            inputLists: [],
            inputLists2: [],
            scanned_ticket:'',
            scanned_ticket2:'',
            ticketItemIdLists: [],
            ticketItemIdLists2: [],
            checkedRA: false,
            isShow: false,
        }
    },
    methods:{
        ShowModal1(){
            this.showScanner = true; 
        }, 
        ShowModal2(){
            this.showScanner2 = true; 
        },
        init(){
            this.inputLists = [];
            this.scanned_ticket = '';
            this.ticketItemIdLists = [];
        },
        init2(){
            this.inputLists2 = [];
            this.scanned_ticket2 = '';
            this.ticketItemIdLists2 = [];
            this.checkedRA = false;
        },
        clear(){
            this.init();
            this.showScanner = false;
        },
        clear2(){
            this.init2();
            this.showScanner2 = false;
            this.checkedRA = false;
        },
        sendToNSRA(){
            let vm = this
            if(!this.ticketItemIdLists || this.ticketItemIdLists.length == 0){
                vm.$bus.fnShowInfo("票券列表為空");
                return
            }
            // 組字串
            // let ticketItemIdStr = this.ticketItemIdLists.join(',');
            // console.log(ticketItemIdStr);
            console.log(typeof(this.ticketItemIdLists))    
            console.log("go to RA");
            this.isShow = true;
            let Param = {
                apiTarget:'ntsa',
                module:'order',
                method:'batchTrashPaperOrderTickets',
                trash_ticket_item_ids: this.ticketItemIdLists,
                phase: 'warehouse',
                force_exec: 0, // 必須NS RA 檢查
            }
            let that = this
            apiBatchTrashPaperOrderTickets(Param).then(function(resp){
                let data = resp.data
                that.init(); 
                that.isShow = false;
                if(data.data){
                    let result = '';
                    if(data.data.hasOwnProperty("IHID")){
                        if(data.data.hasOwnProperty("ra_orders")){
                            result += `拋轉訂單數：${data.data.ra_orders};`
                        }
                        if(data.data.hasOwnProperty("ra_tickets_count")){
                            result += `總共處理票券：${data.data.ra_tickets_count}`
                        }
                        that.init();
                        vm.$bus.fnShowInfo('已拋至NS RA，'+result);      
                        that.showScanner = false;                             
                    }
                }  
            }).catch(function(error){
                let data = error.response.data
                that.init(); 
                that.isShow = false;
                if (data.ok === 0) {
                    // that.init();
                    // 失敗手動清除
                    vm.$bus.fnShowInfo('呼叫失敗:'+ data.msg);
                    that.showScanner = false;
                    return 
                }
            })
            // this.$bus.apiCall(Param, function (data, vm) {
            //     that.init(); 
            //     that.isShow = false;
            //     if (data.ok === 0) {
            //         // that.init();
            //         // 失敗手動清除
            //         vm.$bus.fnShowInfo('呼叫失敗:'+ data.msg);
            //         that.showScanner = false;
            //         return 
            //     }
            //     if(data.data){
            //         let result = '';
            //         if(data.data.hasOwnProperty("IHID")){
            //             if(data.data.hasOwnProperty("ra_orders")){
            //                 result += `拋轉訂單數：${data.data.ra_orders};`
            //             }
            //             if(data.data.hasOwnProperty("ra_tickets_count")){
            //                 result += `總共處理票券：${data.data.ra_tickets_count}`
            //             }
            //             that.init();
            //             vm.$bus.fnShowInfo('已拋至NS RA，'+result);      
            //             that.showScanner = false;                             
            //         }
            //     }                   
            // }, this)
        },
        sendToNSInvalid(){
            let vm = this;
            if(!this.ticketItemIdLists2 || this.ticketItemIdLists2.length == 0){
                vm.$bus.fnShowInfo("票券列表為空");
                return
            }
            // let ticketItemIdStr = this.ticketItemIdLists2.join(',');
            // console.log(ticketItemIdStr);
            let checkOrNot = 0; 
            if(this.checkedRA == true){
                checkOrNot = 1; // 先執行RA 
            }
            console.log("go to Invalid");
            console.log(typeof(this.ticketItemIdLists2))
            // overlay on 
            this.isShow = true;
            let Param = {
                apiTarget:'ntsa',
                module:'order',
                method:'batchTrashPaperOrderTickets',
                trash_ticket_item_ids: this.ticketItemIdLists2,
                phase: 'headquater',
                force_exec: checkOrNot,
            }
            let that = this;
            apiBatchTrashPaperOrderTickets(Param).then(function(resp){
                that.isShow = false;
                let data = resp.data
                if(!data.data.hasOwnProperty("already_done_orders")){
                    //  執行RA的回傳
                    if(checkOrNot == 1){
                        if(data.data.hasOwnProperty("IHID")){
                            vm.$bus.fnShowInfo('執行RA成功!請等30秒再點擊一次執行作廢');
                            // 不清除init2()data，但是勾掉checkbox
                            that.checkedRA = false;
                            that.showScanner2 = false;
                            setTimeout(() => {
                                that.show = false;
                            }, 100);
                            return
                        }
                        vm.$bus.fnShowInfo('其他RA執行結果:'+data.data);
                            // 不清除init2()data，但是勾掉checkbox
                            that.checkedRA = false;
                            that.showScanner2 = false;
                            setTimeout(() => {
                                that.show = false;
                            }, 100);
                            return                        
                    }
                    else {
                        vm.$bus.fnShowInfo('其他執行結果:'+data.data);
                        that.checkedRA = false;
                        that.showScanner2 = false;
                        setTimeout(() => {
                            that.show = false;
                        }, 100);
                        return                        
                    }
                }
                console.log("執行作廢流程")
                let alreadyStr = '無';
                let doneStr = '無';
                let failedStr = '無';
                //已作廢        
                if(data.data.already_done_orders.length !== 0){
                    console.log("已作廢");
                    alreadyStr = '';
                    let alreadyArr = []
                    for(let i = 0; i < data.data.already_done_orders.length; i++){
                        let all = Object.entries(data.data.already_done_orders[i]).filter(item => {
                            return item;
                        });
                        let order_num = all[0];
                        let order_arr = all[1];

                        let order = order_num[1];
                        let total_num = order_arr[1].ord_item_amount;
                        let ticket_num = order_arr[1].tickets.length;
                        alreadyArr.push(`訂單${order}本次執行${ticket_num}張/總共有${total_num}張`);
                    }
                    alreadyStr = alreadyArr.join("\n");
                    console.log(alreadyStr);                                               
                }
                //本次作廢
                if(data.data.done_orders.length !== 0){
                    console.log("本次作廢");
                    doneStr = '';
                    let doneArr = [];
                    for(let i = 0; i < data.data.done_orders.length; i++){
                        let all = Object.entries(data.data.done_orders[i]).filter(item => {
                            return item
                        });
                        let order_num = all[0];
                        let order = order_num[1];

                        let order_arr = all[1];
                        let total_num = order_arr[1].ord_item_amount;
                        let ticket_num = order_arr[1].tickets.length;
                        doneArr.push(`訂單${order}本次執行${ticket_num}張/總共有${total_num}張`);
                    }
                    doneStr = doneArr.join("\n");
                    console.log(doneStr); 
                }
                //本次失敗
                if(data.data.failed_orders.length !== 0){
                    console.log("本次失敗");
                    failedStr = '';
                    let failedArr = [];
                    for(let i = 0; i < data.data.failed_orders.length; i++){
                        let all = Object.entries(data.data.failed_orders[i]).filter(item => {
                            return item
                        });
                        let order_num = all[0];
                        let order_arr = all[1];

                        let order = order_num[1];
                        let total_num = order_arr[1].ord_item_amount;
                        let ticket_num = order_arr[1].tickets.length;
                        failedArr.push(`訂單${order}本次執行${ticket_num}張/總共有${total_num}張`);
                    }
                    failedStr = failedArr.join("\n");
                    console.log(failedStr); 
                }
                // that.init2();
                vm.$bus.fnShowInfo("已經作廢:"+ alreadyStr +'<br>'+"本次成功作廢:"+doneStr+'<br>'+"本次失敗:"+failedStr)
                that.checkedRA = false;
                that.showScanner2 = false; 
                setTimeout(() => {
                    that.show = false;
                }, 100);  
            }).catch(function(error){
                let data = error.response.data
                that.isShow = false;
                if (data.ok === 0) {
                    // 不清除init2()data
                    vm.$bus.fnShowInfo('呼叫失敗:'+ data.msg);
                    that.checkedRA = false;
                    that.showScanner2 = false;
                    setTimeout(() => {
                        that.show = false;
                    }, 100);
                    return 
                }
            })
            // this.$bus.apiCall(Param, function (data, vm) {
            //     // that.init2(); 
            //     that.isShow = false;
            //     if (data.ok === 0) {
            //         // 不清除init2()data
            //         vm.$bus.fnShowInfo('呼叫失敗:'+ data.msg);
            //         that.checkedRA = false;
            //         that.showScanner2 = false;
            //         setTimeout(() => {
            //             that.show = false;
            //         }, 100);
            //         return 
            //     }
            //     if(!data.data.hasOwnProperty("already_done_orders")){
            //         //  執行RA的回傳
            //         if(checkOrNot == 1){
            //             if(data.data.hasOwnProperty("IHID")){
            //                 vm.$bus.fnShowInfo('執行RA成功!請等30秒再點擊一次執行作廢');
            //                 // 不清除init2()data，但是勾掉checkbox
            //                 that.checkedRA = false;
            //                 that.showScanner2 = false;
            //                 setTimeout(() => {
            //                     that.show = false;
            //                 }, 100);
            //                 return
            //             }
            //             vm.$bus.fnShowInfo('其他RA執行結果:'+data.data);
            //                 // 不清除init2()data，但是勾掉checkbox
            //                 that.checkedRA = false;
            //                 that.showScanner2 = false;
            //                 setTimeout(() => {
            //                     that.show = false;
            //                 }, 100);
            //                 return                        
            //         }
            //         else {
            //             vm.$bus.fnShowInfo('其他執行結果:'+data.data);
            //             that.checkedRA = false;
            //             that.showScanner2 = false;
            //             setTimeout(() => {
            //                 that.show = false;
            //             }, 100);
            //             return                        
            //         }
            //     }
            //     console.log("執行作廢流程")
            //     let alreadyStr = '無';
            //     let doneStr = '無';
            //     let failedStr = '無';
            //     //已作廢        
            //     if(data.data.already_done_orders.length !== 0){
            //         console.log("已作廢");
            //         alreadyStr = '';
            //         let alreadyArr = []
            //         for(let i = 0; i < data.data.already_done_orders.length; i++){
            //             let all = Object.entries(data.data.already_done_orders[i]).filter(item => {
            //                 return item;
            //             });
            //             let order_num = all[0];
            //             let order_arr = all[1];

            //             let order = order_num[1];
            //             let total_num = order_arr[1].ord_item_amount;
            //             let ticket_num = order_arr[1].tickets.length;
            //             alreadyArr.push(`訂單${order}本次執行${ticket_num}張/總共有${total_num}張`);
            //         }
            //         alreadyStr = alreadyArr.join("\n");
            //         console.log(alreadyStr);                                               
            //     }
            //     //本次作廢
            //     if(data.data.done_orders.length !== 0){
            //         console.log("本次作廢");
            //         doneStr = '';
            //         let doneArr = [];
            //         for(let i = 0; i < data.data.done_orders.length; i++){
            //             let all = Object.entries(data.data.done_orders[i]).filter(item => {
            //                 return item
            //             });
            //             let order_num = all[0];
            //             let order = order_num[1];

            //             let order_arr = all[1];
            //             let total_num = order_arr[1].ord_item_amount;
            //             let ticket_num = order_arr[1].tickets.length;
            //             doneArr.push(`訂單${order}本次執行${ticket_num}張/總共有${total_num}張`);
            //         }
            //         doneStr = doneArr.join("\n");
            //         console.log(doneStr); 
            //     }
            //     //本次失敗
            //     if(data.data.failed_orders.length !== 0){
            //         console.log("本次失敗");
            //         failedStr = '';
            //         let failedArr = [];
            //         for(let i = 0; i < data.data.failed_orders.length; i++){
            //             let all = Object.entries(data.data.failed_orders[i]).filter(item => {
            //                 return item
            //             });
            //             let order_num = all[0];
            //             let order_arr = all[1];

            //             let order = order_num[1];
            //             let total_num = order_arr[1].ord_item_amount;
            //             let ticket_num = order_arr[1].tickets.length;
            //             failedArr.push(`訂單${order}本次執行${ticket_num}張/總共有${total_num}張`);
            //         }
            //         failedStr = failedArr.join("\n");
            //         console.log(failedStr); 
            //     }
            //     // that.init2();
            //     vm.$bus.fnShowInfo("已經作廢:"+ alreadyStr +'<br>'+"本次成功作廢:"+doneStr+'<br>'+"本次失敗:"+failedStr)
            //     that.checkedRA = false;
            //     that.showScanner2 = false; 
            //     setTimeout(() => {
            //         that.show = false;
            //     }, 100);         
            // }, this)
        },
        parentMethod(inputFromChild) {
            // 傳入邏輯給Scanner
            // console.log(inputFromChild);
            // console.log(this.inputLists);

            // 檢查重覆輸入阻擋 第二張以後開始
            for(let i = 0; i < this.inputLists.length; i++){
                let double_input = this.inputLists.some(x => inputFromChild == x)
                // console.log(inputFromChild);
                // console.log("double", double_input);
                if(double_input == true){
                    this.$bus.fnShowInfo('重覆輸入票號');
                    return 
                }
            }
            // call api
            let Param = {
                module:'admin_manage',
                method:'checkScannedPaperTicket',
                merchant_id: -1,
                ticket_no: inputFromChild,
                qrcode:'',
                credit_number:'',
            }
            let that = this
            apiCheckScannedPaperTicket(Param).then(function(resp){
                let data = resp.data
                if(!data.data || !data.data.ticket_item_id){
                    vm.$bus.fnShowInfo('掃描失敗!找不到data or ticket_item_id');
                    return
                }
                if(data.data){
                    if(data.data.hasOwnProperty("ticket_item_id")){
                        // 成功回傳
                        // 自組inputlist && 組成一個ticket_item_ids
                        // vm.$bus.fnShowInfo('掃描成功!');
                        that.scanned_ticket = inputFromChild;
                        that.inputLists.push(inputFromChild);
                        that.ticketItemIdLists.push(data.data.ticket_item_id);
                        return
                    }
                }
            }).catch(function(error){
                let data = error.response.data
                if (data.ok === 0) {
                    vm.$bus.fnShowInfo('呼叫失敗:'+data.msg);
                    return 
                }
            })
            // this.$bus.apiCall(Param, function (data, vm) {
            //     if (data.ok === 0) {
            //         vm.$bus.fnShowInfo('呼叫失敗:'+data.msg);
            //         return 
            //     }
            //     if(!data.data || !data.data.ticket_item_id){
            //         vm.$bus.fnShowInfo('掃描失敗!找不到data or ticket_item_id');
            //         return
            //     }
            //     if(data.data){
            //         if(data.data.hasOwnProperty("ticket_item_id")){
            //             // 成功回傳
            //             // 自組inputlist && 組成一個ticket_item_ids
            //             // vm.$bus.fnShowInfo('掃描成功!');
            //             that.scanned_ticket = inputFromChild;
            //             that.inputLists.push(inputFromChild);
            //             that.ticketItemIdLists.push(data.data.ticket_item_id);
            //             return
            //         }
            //     }
            // }, this)

        },
        parentMethod2(inputFromChild) {
            // 傳入邏輯給Scanner
            // console.log(inputFromChild);
            // console.log(this.inputLists);

            // 檢查重覆輸入阻擋 第二張以後開始
            for(let i = 0; i < this.inputLists.length; i++){
                let double_input = this.inputLists.some(x => inputFromChild == x)
                // console.log(inputFromChild);
                // console.log("double", double_input);
                if(double_input == true){
                    this.$bus.fnShowInfo('重覆輸入票號');
                    return 
                }
            }
            // call api
            let Param = {
                module:'admin_manage',
                method:'checkScannedPaperTicket',
                merchant_id: -1,
                ticket_no: inputFromChild,
                qrcode:'',
                credit_number:'',
            }
            let that = this
            apiCheckScannedPaperTicket(Param).then(function(resp){
                let data = resp.data
                if(!data.data || !data.data.ticket_item_id){
                    vm.$bus.fnShowInfo('掃描失敗!找不到data or ticket_item_id');
                    return
                }
                if(data.data){
                    if(data.data.hasOwnProperty("ticket_item_id")){
                        // 成功回傳
                        // 自組inputlist && 組成一個ticket_item_ids
                        // vm.$bus.fnShowInfo('掃描成功!');
                        that.scanned_ticket2 = inputFromChild;
                        that.inputLists2.push(inputFromChild);
                        that.ticketItemIdLists2.push(data.data.ticket_item_id);
                        return
                    }
                }
            }).catch(function(error){
                let data = error.response.data
                if (data.ok === 0) {
                    that.$bus.fnShowInfo('呼叫失敗:'+data.msg);
                    return 
                }
            })
            // this.$bus.apiCall(Param, function (data, vm) {
            //     if (data.ok === 0) {
            //         vm.$bus.fnShowInfo('呼叫失敗:'+data.msg);
            //         return 
            //     }
            //     if(!data.data || !data.data.ticket_item_id){
            //         vm.$bus.fnShowInfo('掃描失敗!找不到data or ticket_item_id');
            //         return
            //     }
            //     if(data.data){
            //         if(data.data.hasOwnProperty("ticket_item_id")){
            //             // 成功回傳
            //             // 自組inputlist && 組成一個ticket_item_ids
            //             // vm.$bus.fnShowInfo('掃描成功!');
            //             that.scanned_ticket2 = inputFromChild;
            //             that.inputLists2.push(inputFromChild);
            //             that.ticketItemIdLists2.push(data.data.ticket_item_id);
            //             return
            //         }
            //     }
            // }, this)

        }
    }
}
</script>
<style lang="scss" scoped>
</style>